export default __webpack_public_path__ + "static/media/global.3ed6f06b.svg";